import { QueryClient, useInfiniteQuery } from '@tanstack/react-query'

import { HospitalService, clientHospitalService } from '@/features/hospital/api/hospital.service'
import { Locales } from '@/utils/language'

import type { SearchHospitalsParams } from '@/features/hospital/types/hospital.type'

const INFINITE_SEARCH_HOSPITALS_QUERY_KEY = 'infinite-search-hospitals'

const getQueryKey = (params: SearchHospitalsParams, locale: Locales) => {
  return [
    INFINITE_SEARCH_HOSPITALS_QUERY_KEY,
    params.q || '',
    params.sort || '',
    params.districtCodeList || '',
    params.length || 20,
    locale,
  ]
}
export const useInfiniteSearchHospitals = (params: SearchHospitalsParams, locale: Locales) => {
  return useInfiniteQuery({
    queryKey: getQueryKey(params, locale),
    queryFn: async ({ pageParam = 0 }) =>
      clientHospitalService.searchHospitals({
        ...params,
        start: pageParam * params.length,
      }),
    initialPageParam: 0,
    getNextPageParam: (lastPage, allPages) => {
      const totalItems = lastPage.recordsTotal || 0
      const fetchedItems = allPages.length * params.length
      return fetchedItems < totalItems ? allPages.length : undefined
    },
  })
}

export const prefetchInfiniteSearchHospitals = async (
  queryClient: QueryClient,
  hospitalService: HospitalService,
  params: SearchHospitalsParams,
  locale: Locales,
) => {
  await queryClient.prefetchInfiniteQuery({
    queryKey: getQueryKey(params, locale),
    queryFn: ({ pageParam = 0 }) =>
      hospitalService.searchHospitals({
        ...params,
        start: pageParam * params.length,
      }),
    initialPageParam: 0,
  })

  // prefetch된 데이터 가져오기
  const queryData = queryClient.getQueryData<{ pages: { recordsTotal: number }[] }>(getQueryKey(params, locale))

  return { queryData, queryClient }
}
